import { t } from './index';

/** Maps exact API error messages to i18n keys. */
const API_MESSAGE_KEYS: Record<string, string> = {
  'Invalid payload': 'api.invalidPayload',
  'Invalid query': 'api.invalidQuery',
  'Invalid id': 'api.invalidId',
  'Headstone not found': 'api.headstoneNotFound',
  'Forbidden': 'api.forbidden',
  'Post not found': 'api.postNotFound',
  'Post can only be deleted within 24 hours': 'api.postDeleteWindow',
  'Post can only be edited within 24 hours': 'api.postEditWindow',
  'Coordinates are not allowed on the temple': 'api.templeCoords',
  'Coordinates overlap an existing headstone': 'api.coordsOverlap',
  'Coordinates already occupied': 'api.coordsOccupied',
  'Headstone already owned': 'api.headstoneOwned',
  'Maximum 10 headstones per user': 'api.maxHeadstones',
  'Stripe is not configured': 'api.stripeNotConfigured',
  'imageObjectName does not belong to current user': 'api.imageNotOwned',
  'Internal server error': 'api.internalError',
  'You can light one candle per memorial every 24 hours': 'api.candleCooldown',
  'You can leave one guest message per memorial every 24 hours': 'api.messageCooldown',
  'Owners cannot leave guest tributes on their own memorial': 'api.ownMemorialTribute',
  'Request failed': 'api.generic',
  'Unauthorized': 'api.forbidden',
  'If an account exists for this email, we sent password reset instructions.':
    'auth.forgotSent',
  'Invalid or expired reset token': 'auth.resetTokenMissing',
  'Email service not configured': 'api.emailNotConfigured',
  'Password reset successful': 'auth.resetSuccess',
  'Email verification required': 'auth.verifyBeforePurchase',
  'Pethernity membership required': 'api.pethernityRequired',
  'You can leave one flower per memorial every 24 hours': 'api.flowerCooldown',
  'Gallery photo limit exceeded': 'api.galleryPhotoLimit',
  'Gallery video limit exceeded': 'api.galleryVideoLimit',
  'Invalid or expired invite token': 'api.inviteInvalid',
  'Invalid or expired verification token': 'auth.verifyFailed',
  'Invalid or expired registration code': 'auth.otpInvalid',
};

const IT_QUOTA_RE =
  /^Hai già pubblicato un post questa settimana per (.+)$/;

export function translateApiMessage(message: string | undefined | null): string {
  if (!message) return t('api.generic');
  const key = API_MESSAGE_KEYS[message];
  if (key) return t(key);
  const quota = message.match(IT_QUOTA_RE);
  if (quota) return t('api.postWeeklyQuota', { petName: quota[1] });
  return message;
}

export function translateApiError(err: unknown): string {
  const msg =
    (err as { message?: string })?.message ??
    (typeof err === 'string' ? err : undefined);
  return translateApiMessage(msg);
}
